import { faArrowDown } from '@fortawesome/free-solid-svg-icons/faArrowDown';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './HeaderTableSorter.module.scss';
import { SortOrder } from './sorting';

interface HeaderTableSorterProps {
    order: SortOrder;
    className?: string;
}

export const HeaderTableSorter: FunctionComponent<HeaderTableSorterProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <FontAwesomeIcon
                icon={props.order === SortOrder.ASCENDING ? faArrowUp : faArrowDown}
                className={clsx(styles.container, props.className)}
            />
        </div>
    );
};

export default HeaderTableSorter;
